import React from "react";
import { StyledH2 } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";
import { MenuWrapperAssociate } from "./MenuWrapperAssociate/";

type PrintersPathsModalType = {
    setIsDeviceAssociateModalOpened: Function;
    isDeviceAssociateModalOpened: boolean;
    selectedRows: any;
    isDataUpdated: boolean | number;
    setDataIsUpdated: Function;
    oneShop: boolean;
    rowData:any
};

export default function DeviceAssociateModal({
    setIsDeviceAssociateModalOpened,
    isDeviceAssociateModalOpened,
    selectedRows,
    isDataUpdated,
    setDataIsUpdated,
    oneShop,
    rowData
}: PrintersPathsModalType) {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                className="modal-wrapper__clz modal-assoc__clz"
                isOpen={isDeviceAssociateModalOpened}
            >
                <ModalHeader
                    toggle={() => {
                        setIsDeviceAssociateModalOpened!(
                            !isDeviceAssociateModalOpened
                        );
                        setDataIsUpdated(!isDataUpdated);
                    }}
                >
                    <StyledH2>
                        {capitalize(
                            t("Associate a device with an application")
                        )}
                    </StyledH2>
                </ModalHeader>
                <MenuWrapperAssociate
                    rowData={rowData}
                    setIsDeviceAssociateModalOpened={
                        setIsDeviceAssociateModalOpened
                    }
                    isDeviceAssociateModalOpened={isDeviceAssociateModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={isDataUpdated}
                    oneShop={oneShop}
                    selectedRows ={selectedRows}
                />
            </Modal>
        </React.Fragment>
    );
}
